import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

function PrivateRoute() {
    const url = process.env.REACT_APP_SITE_URL;
    const token = sessionStorage.getItem('token');
    let isAuthenticated = false;
    if (token) {
        isAuthenticated = true;
    }

    return isAuthenticated ? <Outlet /> : <Navigate to={url + 'login'} />
}

export default PrivateRoute;


